import { fetcher } from 'services/helpers/responseHandler'

const getActivity = () => fetcher.get('pms/pep/uploads/activity')

const pepApi = {
  getActivity
}

export default pepApi
